/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseEntryStatisticsField
 */
export interface DatabaseEntryStatisticsField extends DatabaseField {
    /**
     * 'view_count' = Seitenaufrufe zählen (Standard); 'action_count' = Block-Klick zählen
     * @type {string}
     * @memberof DatabaseEntryStatisticsField
     */
    statisticType?: DatabaseEntryStatisticsFieldStatisticTypeEnum;
    /**
     * Block-ID des zu zählenden Blocks (nur bei statisticType = action_count)
     * @type {string}
     * @memberof DatabaseEntryStatisticsField
     */
    actionBlockId?: string;
    /**
     * Wenn true, werden Aufrufe durch den DB-Owner aus Zähler und
     * Aufrufer-Liste ausgeblendet. Filter im Frontend nutzt den
     * byOwner-Flag am ViewRecord (mit Email-Vergleich-Fallback für
     * historische Records). Nur sinnvoll für statisticType = view_count.
     * @type {boolean}
     * @memberof DatabaseEntryStatisticsField
     */
    excludeOwner?: boolean;
}


/**
 * @export
 */
export const DatabaseEntryStatisticsFieldStatisticTypeEnum = {
    ViewCount: 'view_count',
    ActionCount: 'action_count'
} as const;
export type DatabaseEntryStatisticsFieldStatisticTypeEnum = typeof DatabaseEntryStatisticsFieldStatisticTypeEnum[keyof typeof DatabaseEntryStatisticsFieldStatisticTypeEnum];


/**
 * Check if a given object implements the DatabaseEntryStatisticsField interface.
 */
export function instanceOfDatabaseEntryStatisticsField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryStatisticsFieldFromJSON(json: any): DatabaseEntryStatisticsField {
    return DatabaseEntryStatisticsFieldFromJSONTyped(json, false);
}

export function DatabaseEntryStatisticsFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryStatisticsField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'statisticType': !exists(json, 'statisticType') ? undefined : json['statisticType'],
        'actionBlockId': !exists(json, 'actionBlockId') ? undefined : json['actionBlockId'],
        'excludeOwner': !exists(json, 'excludeOwner') ? undefined : json['excludeOwner'],
    };
}

export function DatabaseEntryStatisticsFieldToJSON(value?: DatabaseEntryStatisticsField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'statisticType': value.statisticType,
        'actionBlockId': value.actionBlockId,
        'excludeOwner': value.excludeOwner,
    };
}

